import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../css/Navbar.css';
// ChangeAnoBaseModal removed — year control is inline in the navbar
import useDefaultModal from './hooks/useDefaultModal';
import DefaultModal from './modals/DefaultModal';
import ChangePasswordModal from './modals/ChangePasswordModal';
import { logout } from '../api/logout';

function Navbar({ toggleSidebar }) {
  const [user, setUser] = useState(null);
  const [entidade, setEntidade] = useState(null);
  const [vinculo, setVinculo] = useState(null);
  const [anoBase, setAnoBase] = useState(null);
  const [showChangePassword, setShowChangePassword] = useState(false);
  // modal removed: use inline controls to change year
  const [tabCount, setTabCount] = useState(1);
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const navigate = useNavigate();
  const location = useLocation();
  const storedOptions = localStorage.getItem('vinculos');
  const parsedOptions = storedOptions ? JSON.parse(storedOptions) : [];
  
  const handleLogout = () => {
    const token = localStorage.getItem('token');
    if (token) { logout(token).catch(() => {}); }
    localStorage.clear();
    try { sessionStorage.setItem('justLoggedOut','true'); sessionStorage.removeItem('loginRedirectMessage'); } catch (e) { }
    navigate('/');
  };

  useEffect(() => {
    if (localStorage.getItem('token') === null) {
      navigate('/');
    }
    const userData = localStorage.getItem('user');
    if (userData) {
      setUser(JSON.parse(userData));
    } else {
      navigate('/');
    }
    const entidadeData = localStorage.getItem('entidade');
    if (entidadeData) {
      setEntidade(JSON.parse(entidadeData));
    }
    const vinculoData = localStorage.getItem('vinculo');
    if (vinculoData) {
      setVinculo(JSON.parse(vinculoData));
    }
    const anoBaseData = localStorage.getItem('anoBase');
    if (anoBaseData) {
      setAnoBase(anoBaseData);
    }
  }, [navigate]);

  const MIN_ANO = 2023;
  const MAX_ANO = new Date().getFullYear();

  const clampAno = (y) => Math.max(MIN_ANO, Math.min(MAX_ANO, y));

  const handleChangeAnoDirect = (delta) => {
    if (tabCount > 1) {
      showDefaultModal('error', 'O sistema está aberto em mais de uma aba do navegador. Feche as outras abas para trocar o ano base.');
      return;
    }
    const current = anoBase ? Number(anoBase) : MAX_ANO;
    const newYear = clampAno(current + delta);
    if (newYear === current) return;
    localStorage.setItem('anoBase', String(newYear));
    localStorage.setItem('ano', String(newYear));
    setAnoBase(String(newYear));
    window.location.reload();
  };

  if (!user) {
    return <div>Loading...</div>;
  }

  const isActive = path =>
    location.pathname === path ? 'nav-link active px-2' : 'nav-link px-2';

  return (
    <>
      <nav
        className="navbar navbar-expand-lg navbar-dark fixed-top"
        // Opção de gradiente (descomente se necessário):
        style={{
          background:
            'linear-gradient(45deg, rgb(30, 27, 75) 0%, rgb(55, 48, 163) 100%)',
        }}
      >
      <div className="container-fluid">
        {/* Botão Menu Sidebar - Apenas Mobile */}
        {toggleSidebar && (
          <button
            className="btn btn-link text-white border-0 p-0 d-flex align-items-center justify-content-center d-lg-none"
            onClick={toggleSidebar}
            aria-label="Toggle menu"
            style={{ width: '50px', height: '38px', fontSize: '1.4rem' }}
          >
            <i className="bi bi-list"></i>
          </button>
        )}

        {/* Logo */}
        <a href="/home" className="d-flex align-items-center navbar-brand">
          <img
            src="/assets/logo.png"
            alt="Logo"
            width="140"
            height="40"
            className="d-inline-block align-top me-2 me-lg-3 rounded-3"
          />
        </a>

        {/* Nome da Entidade + Separador + Controle de Ano Base (Desktop) */}
        <div className="d-none d-lg-flex align-items-center gap-2 ms-1">
          {entidade?.nome && (
            <>
              <span
                className="text-white fw-semibold"
                style={{ fontSize: '0.9em', letterSpacing: '0.05em', whiteSpace: 'nowrap' }}
              >
                {entidade.nome}
              </span>
              <span className="text-white opacity-25" style={{ fontSize: '1.1em' }}>|</span>
            </>
          )}
          <div
            className="input-group input-group-sm"
            role="group"
            aria-label="Controle Ano Base"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'ArrowLeft') handleChangeAnoDirect(-1);
              if (e.key === 'ArrowRight') handleChangeAnoDirect(1);
            }}
          >
            <button
              className="btn btn-outline-light btn-sm"
              onClick={() => handleChangeAnoDirect(-1)}
              aria-label="Ano anterior"
              title="Ano anterior"
            >
              <i aria-hidden="true" className="bi bi-chevron-left"></i>
            </button>
            <span
              className="input-group-text text-white bg-transparent border-light"
              aria-live="polite"
              style={{ minWidth: '72px', justifyContent: 'center' }}
            >
              {anoBase || '----'}
            </span>
            <button
              className="btn btn-outline-light btn-sm"
              onClick={() => handleChangeAnoDirect(1)}
              aria-label="Ano posterior"
              title="Ano posterior"
            >
              <i aria-hidden="true" className="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>

        {/* Botão Toggler para Mobile - Menu do Usuário */}
        <button
          className="navbar-toggler border-0"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          aria-label="Menu do usuário"
        >
          <i className="bi bi-person-circle fs-5 text-white"></i>
        </button>
        
        {/* Dropdown do usuário para mobile (toggler) */}
        <ul
          className="dropdown-menu dropdown-menu-end text-white border border-secondary d-lg-none"
          style={{
            minWidth: '220px',
            background:
              'linear-gradient(135deg, rgb(30, 27, 75) 0%, rgb(55, 48, 163) 100%)',
          }}
        >
          <li>
            <div className="px-3 py-2">
              {user?.nome && (
                <div className="text-white fw-semibold">{user.nome}</div>
              )}
              {entidade?.nome && (
                <div className="text-white opacity-75 small">
                  {entidade.nome}
                </div>
              )}
              {anoBase && (
                <div className="input-group input-group-sm" style={{ width: 'auto' }}>
                  <button className="btn btn-outline-light btn-sm" onClick={() => handleChangeAnoDirect(-1)} aria-label="Ano anterior" title="Ano anterior">
                    <i className="bi bi-chevron-left"></i>
                  </button>
                  <span className="input-group-text text-white bg-transparent border-light small" aria-live="polite" style={{ minWidth: '56px', justifyContent: 'center' }}>
                    {anoBase}
                  </span>
                  <button className="btn btn-outline-light btn-sm" onClick={() => handleChangeAnoDirect(1)} aria-label="Ano posterior" title="Ano posterior">
                    <i className="bi bi-chevron-right"></i>
                  </button>
                </div>
              )}
            </div>
          </li>
          <li>
            <hr className="dropdown-divider bg-white mx-2" />
          </li>
          {parsedOptions.length > 1 && (
            <li>
              <a
                className="dropdown-item text-white"
                href="/seleciona_entidade"
              >
                <i className="bi bi-arrow-left-right me-2"></i>
                Trocar Entidade
              </a>
            </li>
          )}
          <li>
            <button
              className="dropdown-item text-white"
              onClick={() => setShowChangePassword(true)}
            >
              <i className="bi bi-key me-2"></i>
              Alterar senha
            </button>
          </li>
          <li>
            <button
              className="dropdown-item text-white"
              onClick={handleLogout}
            >
              <i className="bi bi-box-arrow-right me-2"></i>
              Sair
            </button>
          </li>
        </ul>

        {/* Conteúdo da Navbar - Apenas Desktop */}
        <div className="d-none d-lg-flex flex-row align-items-center gap-3 ms-auto">
          {/* Informações do Usuário */}
          <div className="d-flex flex-column text-end">
            {user?.nome && (
              <span
                className="text-white fw-semibold"
                style={{ fontSize: '0.9em' }}
              >
                {user.nome}
              </span>
            )}
          </div>

          {/* Dropdown do Usuário - Desktop */}
          <div className="nav-item dropdown">
            <button
              className="nav-link dropdown-toggle text-white d-flex align-items-center border-0 bg-transparent"
              id="userDropdownDesktop"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{ cursor: 'pointer' }}
            >
              <i className="bi bi-person-circle fs-5"></i>
            </button>
            <ul
              className="dropdown-menu dropdown-menu-end text-white border border-secondary mt-2"
              style={{
                minWidth: '220px',
                background:
                  'linear-gradient(135deg, rgb(30, 27, 75) 0%, rgb(55, 48, 163) 100%)',
              }}
            >
              {parsedOptions.length > 1 && (
                <li>
                  <a
                    className="dropdown-item text-white"
                    href="/seleciona_entidade"
                  >
                    <i className="bi bi-arrow-left-right me-2"></i>
                    Trocar Entidade
                  </a>
                </li>
              )}
              <li>
                <button
                  className="dropdown-item text-white"
                  onClick={() => setShowChangePassword(true)}
                >
                  <i className="bi bi-key me-2"></i>
                  Alterar senha
                </button>
              </li>
              <li>
                <button
                  className="dropdown-item text-white"
                  onClick={handleLogout}
                >
                  <i className="bi bi-box-arrow-right me-2"></i>
                  Sair
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
    {/* ChangeAnoBaseModal removed: year control is inline */}
    <DefaultModal {...setDefaultModal} />
    <ChangePasswordModal show={showChangePassword} onClose={() => setShowChangePassword(false)} />
    </>
  );
}

export default Navbar;
